import store from '../redux/store'
import { availableRoles } from '../config/roles';

const read_role_name = (role) => {
    if (typeof role === 'string') {
        return role.trim();
    }

    return `${role?.name || role?.role || role?.value || role?.id || ''}`.trim();
};

const read_available_role_key = (role) => {
    const roleName = read_role_name(role).toLowerCase();

    return Object.keys(availableRoles).find((availableRole) => availableRole.toLowerCase() === roleName) || '';
};

const read_role_list = (userRoles) => {
    if (Array.isArray(userRoles)) {
        return userRoles;
    }

    if (typeof userRoles === 'string') {
        return userRoles.split(',').map((role) => role.trim()).filter(Boolean);
    }

    return [];
};

export const checkPermissions = (roleToCheck, userRoles) => {

    let hasAccess = false;
    const roleKeyToCheck = read_available_role_key(roleToCheck) || roleToCheck;
    
    if (!roleToCheck) return true;
    if (!userRoles) userRoles = store.getState()?.user?.user?.roles ?
                                store.getState().user.user.roles: [];

    read_role_list(userRoles).forEach(role => {
        const roleKey = read_available_role_key(role);
        const allowedRoles = availableRoles[roleKey] || [];

        if (allowedRoles.includes(roleKeyToCheck)) hasAccess = true;
    });

    return hasAccess;
}
